import React from 'react';
import './HowItWorks.css';

const steps = [
  { number: '01', title: 'Book a call', description: 'A relaxed 20-minute conversation. Tell us about your space, your frustrations, and what you wish it looked like. No pitch, no commitment.', pill: 'One phone call from you' },
  { number: '02', title: 'Align & design', description: 'We come to your property, walk it with you, and listen. Then we design a fully custom plan — and refine it until every detail feels right.', pill: 'We come to you' },
  { number: '03', title: 'You stay in control', description: "A clear, line-by-line quote before anything starts. No vague estimates, no numbers that shift. You know exactly what you're getting.", pill: 'Every line, explained' },
  { number: '04', title: 'Sit back & enjoy it', description: "We handle everything. Your dedicated contact keeps you updated, we don't stop until you love it — and our care team keeps it that way forever after.", pill: 'Sit back & enjoy' },
];

const HowItWorks = () => (
  <section className="hiw">
    <div className="hiw__inner">
      <div className="hiw__left">
        <span className="hiw__tag">How It Works</span>
        <h2 className="hiw__heading">Simple by <span className="hiw__heading-accent">design.</span></h2>
        <p className="hiw__subtext">We built our process around one idea — you should do as little as possible, and still end up with exactly what you imagined.</p>
      </div>
      <div className="hiw__steps">
        {steps.map(step => (
          <div key={step.number} className="hiw__step">
            <span className="hiw__step-number">{step.number}</span>
            <div className="hiw__step-content">
              <h3 className="hiw__step-title">{step.title}</h3>
              <p className="hiw__step-desc">{step.description}</p>
              {step.pill && <span className="hiw__step-pill">{step.pill}</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
